import styled, { css } from 'styled-components';
import { WrapperDefault } from '../../Shared/Shared';

export const FormInfoWrapper = styled(WrapperDefault)`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 20px 24px;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

export const FormBody = styled.p`
  margin-top: 24px;
  margin-bottom: 42px;
  font-weight: 600;
  line-height: 1.45;
  font-size: 20px;
  max-width: 420px;
`;

export const CompletePaymentButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 45px;
  min-height: 45px;
  border-radius: 22.5px;
  background-color: var(--black);
  color: var(--white);
  font-size: 16px;
  user-select: none;
  border: none;
  cursor: pointer;
`;

export const WarningImageContainer = styled.div`
  margin-bottom: 48px;
  user-select: none;
  svg {
    height: 120px;
    width: 120px;
    stroke: var(--black);
    fill: var(--black);
  }
`;
